import React, { useState, useEffect, useRef } from "react";
import { Dialog } from "primereact/dialog";
import { Toast } from "primereact/toast";

import pdfMake from "pdfmake/build/pdfmake";
// import pdfFonts from "pdfmake/build/vfs_fonts";

import QRCode from 'qrcode';

import Loader from "../../../Base/Components/Loader/Loader";
import { getDateString } from "../../../Base/Services/Moment/Luxon";
import { getLabel } from "../../../Base/Services/Language/LanguageService";
import { formatNumberDecimal } from "../../../Base/Services/FormatTemplate";

import { getCotizacionesCompletas } from "../../../API/Ventas/Cotizaciones/CotizacionesRequest";
import { logoPPFBase64 } from "../../RRHH/Evaluacion/Imgs";
import { ReporteLang } from './ReporteLang'
import { getFirmaPersonal } from "../../../API/Firmas/FirmasRequests";
import { PDFDocument } from "pdf-lib";


// pdfMake.vfs = pdfFonts.pdfMake.vfs;

const ReporteCotizacion = ({ showReporte, setShowReporte, selected, setSelected, lenguaje, getInfo = () => {}, setSelectedEnc = () => {}, setSelectedDet = () => {} }) => {
  const [loading, setLoading] = useState(true);
  const [pdfUrl, setPdfUrl] = useState([]);
  const [pdfUrl2, setPdfUrl2] = useState([]);
  const [pdfUrlCombinado, setPdfUrlCombinado] = useState(null);
  const toast = useRef(null);


  const obtenerInformacion = async(selected) => {
    setLoading(true);
    if (selected.length > 0) {
      const uniqueIdQuotations = [...new Set(selected.map(item => item.IdQuotation))].join(',');
      const resp = await getCotizacionesCompletas(uniqueIdQuotations)

      const imgBlanca = await getFirmaPersonal('111');

      if(resp){
        GenerarReporte(resp[0], imgBlanca)
      }
    }
    setLoading(false);
  };

  const obtenerCantidadPaginas = (doc) => {
    return new Promise((resolve, reject) => {
      doc.getBlob(async (blob) => {
        try {
          const arrayBuffer = await blob.arrayBuffer();
          const pdfDoc = await PDFDocument.load(arrayBuffer);
          const totalPaginas = pdfDoc.getPageCount();
          resolve(totalPaginas);
        } catch (error) {
          reject(error);
        }
      })
    })
  };


  const GenerarReporte = async (datos, imgBlanca) => {
    let Encabezado = datos?.Encabezado
    let Detalles = datos?.Detalles

    let reporte1 = []
    let reporte2 = []

    let CodigoQR
    QRCode.toDataURL(`${Encabezado?.Quotation}`, { errorCorrectionLevel: 'Q' }, (err, url) => { CodigoQR = url })

    const docDefinition = {
      pageSize: "LETTER",
      pageOrientation: "landscape",
      pageMargins: [20, 115, 20, 60],

      // HEADER
      header: function (currentPage, pageCount, pageSize) {
        return [
          {
            widths: ["20%", "*", "15%"],
            columns: [
              [
                {
                  image: logoPPFBase64?.logo,
                  colSpan: 2,
                  width: 180,
                  margin: [30, 0, 0, 0],
                },
                {},
              ],
              [
                {
                  text: "PRIDE PERFORMANCE FABRICS S.A. DE C.V.",
                  style: "titulo2",
                  margin: [-20, 30, 0, 0],
                },
                {
                  text: `Zona libre Pride Performance Fabrics, S.A. de CV. Km 19.5 carretera a occidente, la Acequia, Naco, Quimistán, Santa Bárbara, Honduras.`,
                  style: "titulo3",
                  margin: [-20, 5, 0, 0],
                  fillColor: "#FF0000",
                },
              ],
              [
                {
                  text: `${getLabel(ReporteLang, "cotizacion", lenguaje)}\n ${Encabezado?.Quotation}`,
                  style: "titulo",
                  margin: [85, 20, 0, 0],
                },
                {
                  image: CodigoQR,
                  width: 60,
                  margin: [145, -2, 0, 0],
                },
              ],
            ],
          },
        ];
      },

      footer: (currentPage, pageCount) => {
        return {
          table: {
            widths: [450],
            body: [
              [
                {
                  text: `${getLabel( ReporteLang, "Pagina", lenguaje )} ${currentPage} / ${pageCount + 2}`,
                  margin: [380, 10, -20, 0],
                  fontSize: 7.5,
                },
              ],
              [
                {
                  text: `${getLabel(ReporteLang, "datePrint", lenguaje)}: ` + getDateString(new Date()),
                  margin: [30, -20, 30, 0],
                  style: 'textBody1'
                },
              ],
            ],
          },
          layout: {
            fillColor: function (rowIndex, node, columnIndex) {
              return rowIndex % 2 === 0 ? "#FFFFFF" : null;
            },
            defaultBorder: false,
          }
        };
      },

      content: [

        //TABLA INICIAL
        {
          table: {
            widths: ["*", "25%"], 
            body: [
              [
                {
                  text: `${getLabel(ReporteLang, "fecha", lenguaje)} ${getDateString(new Date(Encabezado.Date || ""))}`,
                  style: "infoGeneral",
                  margin: [10, 0, 0, 0],
                  border: [false, false, false, false]
                },
                {
                  text: `${getLabel(ReporteLang, "agente", lenguaje)} ${Encabezado.UserNameAgent || ""}`,
                  style: "infoGeneral",
                  border: [false, false, false, false]

                },
              ], 
              [
                {
                  text: `${getLabel(ReporteLang, "cliente", lenguaje)} ${Encabezado.CustomerName || ""}`,
                  style: "infoGeneral",
                  margin: [10, 0, 0, 0],

                  border: [false, false, false, false]
                },
                {
                  text: `${getLabel(ReporteLang, "terminoC", lenguaje)} ${Encabezado.TermNamePayment || ""}`,
                  style: "infoGeneral",
                  border: [false, false, false, false]
                },
              ], 
              [
                {
                  text: `${getLabel(ReporteLang, "Buyer", lenguaje)} ${Encabezado.CompanyName || ""}`,
                  style: "infoGeneral",
                  border: [false, false, false, false],
                  margin: [10, 0, 0, 0],
                },
                {
                  text: `${getLabel(ReporteLang, "terminoE", lenguaje)} ${Encabezado.TermNameShitment || ""}`,
                  style: "infoGeneral",
                  border: [false, false, false, false],
                },
              ], 
              [
                {
                  text: `${getLabel(ReporteLang, "Origin", lenguaje)}: ${Encabezado?.Origin || ""}`,
                  style: "infoGeneral",
                  margin: [10, 0, 0, 5],
                  border: [false, false, false, true],
                  colSpan: 2,
                },{},
              ], 
            ],
          },
          margin: [0, 0, 0, 0],
        },

    
        {
          columns: [
            {
              margin: [5, 15, 5, 0],
              table: {
                widths: ['8%', '10%', '25%', '10%', '*', '*', '*', '*', '*', '*'],
                body: [
                  [
                    { text: ``, style: "headerTable", colSpan: 7, border: [false, false, false, false] }, {}, {}, {}, {}, {},{},
                    { text: `${getLabel(ReporteLang, "CIFPRICES", lenguaje)}`, style: "headerTable", colSpan: 3, },{},{},
                  ],
                  [
                    { text: `${getLabel(ReporteLang, "CONTENT", lenguaje)}`, style: "headerTable", border: [false, false, false, true], },
                    { text: `${getLabel(ReporteLang, "TYPE", lenguaje)}`, style: "headerTable", border: [false, false, false, true], },
                    { text: `${getLabel(ReporteLang, "YARN", lenguaje)}`, style: "headerTable", border: [false, false, false, true], },
                    { text: `${getLabel(ReporteLang, "PROCESS", lenguaje)}`, style: "headerTable", border: [false, false, false, true], },
                    { text: `${getLabel(ReporteLang, "WEIGHT GSM", lenguaje)}`, style: "headerTable", border: [false, false, false, true], },
                    { text: `${getLabel(ReporteLang, "CUTTABLE GSM", lenguaje)}`, style: "headerTable", border: [false, false, false, true], },
                    { text: `${getLabel(ReporteLang, "FULL WIDTH", lenguaje)}`, style: "headerTable", border: [false, false, false, true], },
                    { text: `${getLabel(ReporteLang, "KG", lenguaje)}`, style: "headerTable", border: [true, false, false, true], },
                    { text: `${getLabel(ReporteLang, "LB", lenguaje)}`, style: "headerTable", border: [false, false, false, true], },
                    { text: `${getLabel(ReporteLang, "YD", lenguaje)}`, style: "headerTable", border: [false, false, true, true], },
                  ],
                  ...Detalles.flatMap(d => [
                    [
                      { text: `${d?.FabricType || ""}`, style: 'textBody', border: [false, false, false, true], },
                      { text: `${d?.FabricContent || ""}`, style: 'textBody',  border: [false, false, false, true], },
                      { text: `${d?.YarnSpec || ""}`, style: 'textBody',  border: [false, false, false, true],},
                      { text: `${d?.Process || ""}`, style: 'textBody',  border: [false, false, false, true],},
                      { text: `${formatNumberDecimal(d.WeightGSM)}`, style: 'textBody',  border: [false, false, false, true], },
                      { text: `${formatNumberDecimal(d.CuttableGSM)}`, style: 'textBody',  border: [false, false, false, true], },
                      { text: `${formatNumberDecimal(d.FullWidth)}`, style: 'textBody',  border: [false, false, false, true], },
                      { text: `$ ${formatNumberDecimal(d.CifPriceKG)}`, style: 'textBody',  border: [true, false, false, true], },
                      { text: `$ ${formatNumberDecimal(d.CifPriceLB)}`, style: 'textBody',  border: [false, false, false, true], },
                      { text: `$ ${formatNumberDecimal(d.CifPriceYD)}`, style: 'textBody',  border: [false, false, true, true], },
                    ],
                  ]),
                  // [
                  //   { text: ``, style: "textBody2", border: [false, false, false, false] },
                  //   { text: ``, style: "textBody2", border: [false, false, false, false] },
                  //   { text: ``, style: "textBody2", border: [false, false, false, false] },
                  //   { text: ``, style: "textBody2", border: [false, false, false, false] },
                  //   { text: ``, style: "textBody2", border: [false, false, false, false] },
                  //   { text: ``, style: "textBody2", border: [false, false, false, false] },
                  //   { text: `$ ${formatNumberDecimal(Encabezado.CifPriceKGTOT)}`, style: "textBody", margin: [0,3,0,0], border: [true, false, false, true],},
                  //   { text: `$ ${formatNumberDecimal(Encabezado.CifPriceLBTOT)}`, style: "textBody", margin: [0,3,0,0], border: [false, false, false, true],},
                  //   { text: `$ ${formatNumberDecimal(Encabezado.CifPriceYDTOT)}`, style: "textBody", margin: [0,3,0,0], border: [false, false, true, true],},
                  // ],
                ],
              },
              // layout: {
              //   hLineColor: function (i, node) {
              //     return i === 0 || '#AAAAAA';
              //   },
              //   vLineColor: function (i, node) {
              //     return i === 0 || '#AAAAAA';
              //   },
              // },
              layout: 'lightHorizontalLines'
            },
          ],
        },

        
        //COMENTARIO
        {
          text: [
            {
              text: `${getLabel(ReporteLang, "comentario", lenguaje)}: `,
              style: 'titulo2', 
            },
            {
              text: `${Encabezado?.Comment || ''}`,
              style: 'general',
            },
          ],
          margin: [20, 30, 10, 0],
        },


        // {
        //   table: {
        //     widths: ['62%', '25%', '10%'],
        //     body: [
        //       [
        //         { text: "", border: [false, false, false, false] }, 
        //         { text: `${getLabel(ReporteLang, "Price", lenguaje)}` + " KG:", style: 'textTotales', margin: [0, 35, 0, 0] , border: [false, false, false, false]}, 
        //         { 
        //           text:`$ ${formatNumberDecimal(`${Encabezado?.CifPriceKGTOT}`)}` || 0, 
        //           style: "textTotales2",  
        //           margin: [-5, 35, 0, 0] ,
        //           border: [false, false, false, false]
        //         } 
        //       ],
        //       [
        //         { text: "", border: [false, false, false, false] }, 
        //         { text: `${getLabel(ReporteLang, "Price", lenguaje)} ` + "LB:", style: 'textTotales', margin: [0, 0, 0, 0], border: [false, false, false, false] }, 
        //         { 
        //           text: `$ ${formatNumberDecimal(`${Encabezado?.CifPriceLBTOT}`)}` || 0, 
        //           style: "textTotales2",  
        //           margin: [-5, 0, 0, 0] ,border: [false, false, false, false]
        //         }
        //       ],
        //       [
        //         { text: "", border: [false, false, false, false] }, 
        //         { text: `${getLabel(ReporteLang, "Price", lenguaje)}` + " YD:", style: 'textTotales', margin: [0, 0, 0, 40], border: [false, false, false, false] }, 
        //         { 
        //           text: `$ ${formatNumberDecimal(`${Encabezado?.CifPriceYDTOT}`)}` || 0, 
        //           style: "textTotales2",  
        //           margin: [-5, 0, 0, 40] ,
        //           border: [false, false, false, false]
        //         } 
        //       ]
        //     ]
        //   }
        // },
        

        //FIRMA
        {
          columns: [
            {
              margin: [0, 60, 0, 0],
  
              table: {
                widths: [250, '*', 250],
                body: [
                  [
                    {
                      border: [false, false, false, false],
                      text: '',
                    },
                    {
                      border: [false, false, false, false],
                      image: imgBlanca ? "data:image/png;base64," + imgBlanca : null,
                      width: 50,
                    },
                    {
                      border: [false, false, false, false],
                      text: '', 
                    },
                  ],
                  [
                    {
                      border: [false, false, false, false],
                      text: '',
                    },
                    {
                      border: [false, true, false, false],
                      text: `${getLabel(ReporteLang,"firma",lenguaje)}`,
                      // image: "data:image/png;base64," + imgBlanca,
                      style: 'firmas', 

                    },
                    {
                      border: [false, false, false, false],
                      text: '',
                    },
                  ]

                ]
              }
            }
          ]
        },

      ],

      // ESTILOS
      styles: {
        titulo: {
          fontSize: 11,
          bold: true,
          alignment: "center",
        },
        titulo2: {
          fontSize: 8.5,
          bold: true,
          alignment: "justify",
        },
        general: {
          fontSize: 8.5,
          alignment: "justify",
        },
        titulo3: {
          fontSize: 8.5,
          semmibold: true,
          alignment: "justify",
        },
        header: {
          fontSize: 9,
          alignment: "justify",
          bold: true,
        },
        infoGeneral: {
          fontSize: 8.5,
          alignment: 'justify'
        },
        headerTable: {
          fontSize: 7.5,
          alignment: "center",
          bold: true,
        },
        headerTable1: {
          fontSize: 8,
          // alignment: "center",
          bold: true,
        },
        textBody: {
          fontSize: 8,
          alignment: "center",
        },  
        textBody1: {
          fontSize: 8,
          alignment: "justify",
        },   
        textBody2: {
          fontSize: 8,
          alignment: "right",
        },            
        textTotales: {
          bold: true,
          fontSize: 10,
          alignment: "right",
        },
        textTotales2: {
          // bold: true,
          fontSize: 10,
          alignment: "right",
        },
        footer: {
          fontSize: 7.5,
          alignment: "left",
          margin: [30, 0, 5, 0],
        },
        firmas: {
          fontSize: 8,
          bold: true,
          alignment: "center",
          lineHeight: 1,
        },
        //CONTENIDO
        title: {
          fontSize: 13,
          bold: true,
          alignment: "center",
        },
        text1: {
          fontSize: 9,
          alignment: "justify",
        },
        text1_1: {
          fontSize: 9,
          alignment: "justify",
          bold: true,
        },
        text2: {
          fontSize: 9,
          bold: true,
          alignment: "justify",
        },
        textBlue: {
          fontSize: 9,
          bold: true,
          alignment: "justify",
          color: "blue",
        },
        textRed: {
          fontSize: 9,
          bold: true,
          alignment: "justify",
          color: "red",
        },
      },
    };

    const doc = pdfMake.createPdf(docDefinition);

    await new Promise((resolve) => {
      doc.getDataUrl((url) => {
        reporte1.push(url);
        resolve();
      });
    });

    setPdfUrl(reporte1);



    let cantPag = await obtenerCantidadPaginas(doc);


    const docDefinitionDoc = {
      pageSize: "LETTER",
      pageOrientation: "portrait",
      pageMargins: [40, 115, 40, 60],

      // HEADER
      header: function (currentPage, pageCount, pageSize) {
        return [
          {
            widths: ["20%", "*", "15%"],
            columns: [
              [
                {
                  image: logoPPFBase64?.logo,
                  width: 180,
                  margin: [20, 10, -10, -10],
                  border: [true, true, true, true],
                },
                {},
              ],
              [
                {
                  text: "PRIDE PERFORMANCE FABRICS S.A. DE C.V.",
                  style: "titulo2",
                  margin: [-20, 30, 0, 0],
                },
                {
                  text: `Zona libre Pride Performance Fabrics, S.A. de CV. Km 19.5 \ncarretera a occidente, la Acequia, Naco, Quimistán, \nSanta Bárbara, Honduras.`,
                  style: "titulo3",
                  margin: [-20, 5, 0, 0],
                  fillColor: "#FF0000",
                },
              ],
              [
                {
                  text: `${getLabel(ReporteLang, "cotizacion", lenguaje)}\n ${Encabezado?.Quotation}`,
                  style: "titulo",
                  margin: [0, 20, 0, 0],
                },
                {
                  image: CodigoQR,
                  width: 60,
                  margin: [75, -2, 0, 0],
                },
              ],
            ],
          },
        ];
      },

      footer: (currentPage, pageCount) => {
        return {
          table: {
            widths: [450],
            body: [
              [
                {
                  text: `${getLabel( ReporteLang, "Pagina", lenguaje )} ${currentPage + cantPag} / ${pageCount + cantPag}`,
                  margin: [280, 10, -20, 0],
                  fontSize: 7.5,
                },
              ],
              [
                {
                  text: `${getLabel(ReporteLang, "datePrint", lenguaje)}: ` + getDateString(new Date()),
                  margin: [30, -20, 30, 0],
                  style: 'textBody1'
                },
              ],
            ],
          },
          layout: {
            fillColor: function (rowIndex, node, columnIndex) {
              return rowIndex % 2 === 0 ? "#FFFFFF" : null;
            },
            defaultBorder: false,
          }
        };
      },

      content: [
        //CONTENIDO
        {
          text: `${getLabel(ReporteLang,"title",lenguaje)}`,
          style: 'title', 
        },
        {
          text: `${getLabel(ReporteLang,"text1",lenguaje)}`,
          style: 'text1', 
          margin: [15, 15, 15, 0],
        },
        {
          text: `${getLabel(ReporteLang,"text2",lenguaje)}`,
          style: 'text1', 
          margin: [15, 15, 15, 0],
        },
        {
          text: `${getLabel(ReporteLang,"payment",lenguaje)}`,
          style: 'text2', 
          margin: [15, 15, 15, 0],
        },
        {
          text: [
            {
              text: `${getLabel(ReporteLang, "text3", lenguaje)}`, 
              style: 'text1',
            },
            {
              text: ` ${Encabezado?.TermNamePayment || ''}`,  
              style: 'textBlue',
            },
            {
              text: `${getLabel(ReporteLang, "text3_2", lenguaje)}`,  
              style: 'text1',
            }
          ],
          margin: [35, 5, 15, 0], 
        },
        {
          text: [
            {
              text: `${getLabel(ReporteLang,"text4",lenguaje)}`,
              style: 'text1', 
            },
            {
              text: `${Encabezado?.PorcentajePenalizacion || '0'}`,
              style: 'textRed', 
            },
            {
              text: `${getLabel(ReporteLang,"text4_1",lenguaje)}`,
              style: 'textRed', 
            },
            {
              text: `${getLabel(ReporteLang,"text4_2",lenguaje)}`,
              style: 'text1', 
            },
          ],
          margin: [35, 5, 15, 0],
        },
        {
          text: `${getLabel(ReporteLang,"bank",lenguaje)}`,
          style: 'text2', 
          margin: [15, 15, 15, 0],
        },
        {
          text: `${getLabel(ReporteLang,"text5",lenguaje)}`,
          style: 'text1', 
          margin: [35, 5, 15, 0],
        },
        {
          text: `${getLabel(ReporteLang,"text6",lenguaje)}`,
          style: 'text1', 
          margin: [45, 5, 15, 0],
        },
        {
          text: [
            {
              text: `${getLabel(ReporteLang,"shipping",lenguaje)}`,
              style: 'text2', 
            },
            {
              text: [
                {
                  text: ` ${Encabezado?.Porcentaje || '0'}`,
                  style: 'text1', 
                },
                {
                  text: `${getLabel(ReporteLang,"text7",lenguaje)}`,
                  style: 'text1', 
                },
              ]
            }
          ],
          margin: [15, 15, 15, 0],
        },
        {
          text: `${getLabel(ReporteLang,"yarn",lenguaje)}`,
          style: 'text2', 
          margin: [15, 15, 15, 0],
        },
        {
          text: `${getLabel(ReporteLang,"text8",lenguaje)}`,
          style: 'text1', 
          margin: [35, 5, 15, 0],
        },
        {
          text: `${getLabel(ReporteLang,"Non",lenguaje)}`,
          style: 'text2', 
          margin: [15, 15, 15, 0],
        },
        {
          text: [
            {
              text: `${getLabel(ReporteLang,"text9",lenguaje)}`,
              style: 'text1', 
            },
            {
              text: `${getLabel(ReporteLang,"text9_1",lenguaje)}`,
              style: 'text1_1', 
            },
            {
              text: `${getLabel(ReporteLang,"text9_2",lenguaje)}`,
              style: 'text1', 
            },
            {
              text: `${getLabel(ReporteLang,"text9_3",lenguaje)}`,
              style: 'text1_1', 
            },
            {
              text: `${getLabel(ReporteLang,"text9_4",lenguaje)}`,
              style: 'text1', 
            },
          ],
          margin: [35, 5, 15, 0],
        },
        {
          text: [
            {
              text: `${getLabel(ReporteLang,"text10",lenguaje)}`,
              style: 'text1', 
            },
            {
              text: `${getLabel(ReporteLang,"text10_1",lenguaje)}`,
              style: 'text1_1', 
            },
            {
              text: `${getLabel(ReporteLang,"text10_2",lenguaje)}`,
              style: 'text1', 
            },
          ],
          margin: [35, 5, 15, 0],
        },
        {
          text: `${getLabel(ReporteLang,"validation",lenguaje)}`,
          style: 'text2', 
          margin: [15, 15, 15, 0],
        },
        {
          text: [
            {
              text: `${getLabel(ReporteLang,"text11",lenguaje)}`,
              style: 'text1', 
            },
            {
              text: `${getLabel(ReporteLang,"text11_1",lenguaje)}`,
              style: 'text1_1', 
            },
            {
              text: `${getLabel(ReporteLang,"text11_2",lenguaje)}`,
              style: 'text1', 
            },
          ],
          margin: [35, 5, 15, 0],
        },
        {
          text: `${getLabel(ReporteLang,"text12",lenguaje)}`,
          style: 'text1', 
          margin: [35, 5, 15, 0],
        },
        {
          text: [
            {
              text: `${getLabel(ReporteLang,"text13",lenguaje)}`,
              style: 'text1', 
            },
            {
              text: `${Encabezado?.CustomerName || ''}`,
              style: 'text1', 
            },
            {
              text: `${getLabel(ReporteLang,"text13_1",lenguaje)}`,
              style: 'text1', 
            },
            {
              text: `${Encabezado?.CustomerName || ''}`,
              style: 'text1', 
            },
            {
              text: `${getLabel(ReporteLang,"text13_2",lenguaje)}`,
              style: 'text1', 
            },
            {
              text: `${Encabezado?.CustomerName || ''}`,
              style: 'text1', 
            },
            {
              text: `${getLabel(ReporteLang,"text13_3",lenguaje)}`,
              style: 'text1', 
            },
            
          ],
          margin: [35, 5, 15, 0],
        },
        {
          text:[
            {
              text: `${getLabel(ReporteLang,"text14",lenguaje)}`,
              style: 'text1', 
            },
            {
              text: `${getLabel(ReporteLang,"text14_1",lenguaje)}`,
              style: 'text1_1', 
            },
            {
              text: `${getLabel(ReporteLang,"text14_2",lenguaje)}`,
              style: 'text1', 
            },
          ],
          margin: [35, 5, 15, 0],
        },
        {
          text: [
            {
              text: `${getLabel(ReporteLang,"text15",lenguaje)}`,
              style: 'text1', 
            },
            {
              text: `${getLabel(ReporteLang,"text15_1",lenguaje)}`,
              style: 'text1_1', 
            },
          ],
          margin: [35, 5, 15, 50],
        },
        {
          text: `${getLabel(ReporteLang,"return",lenguaje)}`,
          style: 'text2', 
          margin: [15, 15, 15, 0],
        },
        {
          text: `${getLabel(ReporteLang,"text16",lenguaje)}`,
          style: 'text1', 
          margin: [35, 10, 15, 0],
        },
        {
          text: `${getLabel(ReporteLang,"types",lenguaje)}`,
          style: 'text2', 
          margin: [15, 15, 15, 0],
        },
        {
          text: `${getLabel(ReporteLang,"text17",lenguaje)}`,
          style: 'text1', 
          margin: [35, 5, 15, 0],
        },
        {
          text: `${getLabel(ReporteLang,"cargos",lenguaje)}`,
          style: 'text2', 
          margin: [15, 15, 15, 0],
        },
        {
          text: `${getLabel(ReporteLang,"text18",lenguaje)}`,
          style: 'text1', 
          margin: [35, 5, 15, 0],
        },
        {
          text: `${getLabel(ReporteLang,"text19",lenguaje)}`,
          style: 'text1', 
          margin: [35, 5, 15, 0],
        },
        {
          text: `${getLabel(ReporteLang,"text20",lenguaje)}`,
          style: 'text1', 
          margin: [35, 5, 15, 0],
        },
        {
          text: `${getLabel(ReporteLang,"text21",lenguaje)}`,
          style: 'text1', 
          margin: [35, 5, 15, 0],
        },
        {
          text: `${getLabel(ReporteLang,"fuerza",lenguaje)}`,
          style: 'text2', 
          margin: [15, 15, 15, 0],
        },
        {
          text: [
            {
              text: `${getLabel(ReporteLang,"text22",lenguaje)}`,
              style: 'text1', 
            },
            {
              text: `${getLabel(ReporteLang,"text22_1",lenguaje)}`,
              style: 'text1_1', 
            },
            {
              text: `${getLabel(ReporteLang,"text22_2",lenguaje)}`,
              style: 'text1', 
            },
          ], 
          margin: [35, 5, 15, 0],
        },
        {
          text: `${getLabel(ReporteLang,"text23",lenguaje)}`,
          style: 'text1', 
          margin: [15, 25, 15, 0],
        },


        //FIRMAS
        {
          columns: [
            {
              margin: [30, 125, 30, 0],
              table: {
                widths: ['*', '*', '*'],
                body: [
                  [
                    {
                      border: [false, true, false, false],
                      text: `${getLabel(ReporteLang,"firmaContenido",lenguaje)}`,
                      style: 'firmas', 
                    },
                    {
                      border: [false, false, false, false],
                      text: '', width: [100]
                    },
                    {
                      border: [false, true, false, false],
                      text: `${getLabel(ReporteLang,"firmaContenido",lenguaje)}`,
                      style: 'firmas', 
                    },
                  ],
                  [
                    {
                      border: [false, false, false, false],
                      text: `${getLabel(ReporteLang,"firmaContenido1",lenguaje)}`,
                      style: 'firmas', 
                    },
                    {
                      border: [false, false, false, false],
                      text: '', width: [100]
                    },
                    {
                      border: [false, false, false, false],
                      text: `${Encabezado?.CustomerName || ''}`,
                      style: 'firmas', 
                    },
                  ]
                ]
              }
            }
          ]
        },

      ],

      // ESTILOS
      styles: {
        titulo: {
          fontSize: 11,
          bold: true,
          alignment: "center",
        },
        titulo2: {
          fontSize: 8.5,
          bold: true,
          alignment: "justify",
        },
        general: {
          fontSize: 8.5,
          alignment: "justify",
        },
        titulo3: {
          fontSize: 8.5,
          semmibold: true,
          alignment: "justify",
        },
        header: {
          fontSize: 9,
          alignment: "justify",
          bold: true,
        },
        infoGeneral: {
          fontSize: 8.5,
          alignment: 'justify'
        },
        headerTable: {
          fontSize: 7.5,
          alignment: "center",
          bold: true,
        },
        headerTable1: {
          fontSize: 8,
          // alignment: "center",
          bold: true,
        },
        textBody: {
          fontSize: 8,
          alignment: "center",
        },  
        textBody1: {
          fontSize: 8,
          alignment: "justify",
        },   
        textBody2: {
          fontSize: 8,
          alignment: "right",
        },            
        textTotales: {
          bold: true,
          fontSize: 10,
          alignment: "right",
        },
        textTotales2: {
          // bold: true,
          fontSize: 10,
          alignment: "right",
        },
        footer: {
          fontSize: 7.5,
          alignment: "left",
          margin: [30, 0, 5, 0],
        },
        firmas: {
          fontSize: 8,
          bold: true,
          alignment: "center",
          lineHeight: 1,
        },
        //CONTENIDO
        title: {
          fontSize: 13,
          bold: true,
          alignment: "center",
        },
        text1: {
          fontSize: 9,
          alignment: "justify",
        },
        text1_1: {
          fontSize: 9,
          alignment: "justify",
          bold: true,
        },
        text2: {
          fontSize: 9,
          bold: true,
          alignment: "justify",
        },
        textBlue: {
          fontSize: 9,
          bold: true,
          alignment: "justify",
          color: "blue",
        },
        textRed: {
          fontSize: 9,
          bold: true,
          alignment: "justify",
          color: "red",
        },
      },
    };

    const doc2 = pdfMake.createPdf(docDefinitionDoc);


    await new Promise((resolve) => {
      doc2.getDataUrl((url) => {
        reporte2.push(url);
        resolve();
      });
    });

    setPdfUrl2(reporte2);

  };

  const combinarPDFs = async (pdf1, pdf2) => {
    const dataUnida = [...pdf1, ...pdf2];
  
    if (!dataUnida || dataUnida.length === 0) {
      return;
    }

    try {
      const pdfDoc = await PDFDocument.create();

      for (const pdfBase64 of dataUnida) {
        const pdfBytes = await fetch(pdfBase64).then((res) =>
          res.arrayBuffer()
        );
        const pdfDocTemp = await PDFDocument.load(pdfBytes);
        const pages = await pdfDoc.copyPages(
          pdfDocTemp,
          pdfDocTemp.getPageIndices()
        );
        pages.forEach((page) => pdfDoc.addPage(page));
      }

      // console.log(pdfDoc.getPageCount(),'**************');

      const mergedPdfBytes = await pdfDoc.save();

      // Crear un Blob y una URL temporal
      const blob = new Blob([mergedPdfBytes], { type: "application/pdf" });
      const blobUrl = URL.createObjectURL(blob);

      setPdfUrlCombinado(blobUrl); // Seteamos la URL combinada del PDF
    } catch (error) {
      console.error("Error al combinar los PDFs:", error);
    }
  };

  const onHideReporte = () => {
    setShowReporte(false);
    setSelected([])
    setSelectedEnc([])
    setSelectedDet([])
    getInfo()
  };

  useEffect(() => {
    if(pdfUrl && pdfUrl2){
      combinarPDFs(pdfUrl, pdfUrl2);
    }
  }, [pdfUrl, pdfUrl2]);

  useEffect(() => {
    if (showReporte) {
      obtenerInformacion(selected);
    }
  }, [showReporte]);

  return (
    <Dialog
      visible={showReporte}
      onHide={onHideReporte}
      style={{ width: "63vw", height: "85vh" }}
    >
      <Loader loading={loading} querySelector={"#Modal"} />
      <Toast ref={toast} />
      <div id="Modal">
        {!loading && pdfUrlCombinado && (
          <iframe
            src={pdfUrlCombinado}
            style={{ width: "60vw", height: "75vh", border: "1px solid #ccc" }}
            id="foo"
            title="Reporte QR PDF"
          />
        )}
      </div>
    </Dialog>
  );
};

export default ReporteCotizacion;


// const GenerarReporte = (datos, imgBlanca) => {
//   let Encabezado = datos?.Encabezado
//   let Detalles = datos?.Detalles

//   let CodigoQR
//   QRCode.toDataURL(`${Encabezado?.Quotation}`, { errorCorrectionLevel: 'Q' }, (err, url) => { CodigoQR = url })

//   const docDefinition = {
//     pageSize: "LETTER",
//     pageOrientation: "portrait",
//     pageMargins: [40, 115, 40, 60],

//     // HEADER
//     header: function (currentPage, pageCount, pageSize) {
//       return [
//         {
//           widths: ["20%", "*", "15%"],
//           columns: [
//             [
//               {
//                 image: logoPPFBase64?.logo,
//                 width: 180,
//                 margin: [20, 10, -10, -10],
//                 border: [true, true, true, true],
//               },
//               {},
//             ],
//             [
//               {
//                 text: "PRIDE PERFORMANCE FABRICS S.A. DE C.V.",
//                 style: "titulo2",
//                 margin: [-20, 30, 0, 0],
//               },
//               {
//                 text: `Zona libre Pride Performance Fabrics, S.A. de CV. Km 19.5 \ncarretera a occidente, la Acequia, Naco, Quimistán, \nSanta Bárbara, Honduras.`,
//                 style: "titulo3",
//                 margin: [-20, 5, 0, 0],
//                 fillColor: "#FF0000",
//               },
//             ],
//             [
//               {
//                 text: `${getLabel(ReporteLang, "cotizacion", lenguaje)}\n ${Encabezado?.Quotation}`,
//                 style: "titulo",
//                 margin: [0, 20, 0, 0],
//               },
//               {
//                 image: CodigoQR,
//                 width: 60,
//                 margin: [75, -2, 0, 0],
//               },
//             ],
//           ],
//         },
//       ];
//     },

//     footer: (currentPage, pageCount) => {
//       return {
//         table: {
//           widths: [450],
//           body: [
//             [
//               {
//                 text: `${getLabel(
//                   ReporteLang,
//                   "Pagina",
//                   lenguaje
//                 )} ${currentPage} / ${pageCount}`,
//                 margin: [280, 10, -20, 0],
//                 fontSize: 7.5,
//               },
//             ],
//             [
//               {
//                 text: `${getLabel(ReporteLang, "datePrint", lenguaje)}: ` + getDateString(new Date()),
//                 margin: [30, -20, 30, 0],
//                 style: 'textBody1'
//               },
//             ],
          
//           ],
//         },
//         layout: {
//           fillColor: function (rowIndex, node, columnIndex) {
//             return rowIndex % 2 === 0 ? "#FFFFFF" : null;
//           },
//           defaultBorder: false,
//         }
//       };
//     },

//     content: [

//       //TABLA INICIAL
//       {
//         table: {
//           widths: ["*", "30%"], 
//           body: [
//             [
//               {
//                 text: `${getLabel(ReporteLang, "fecha", lenguaje)} ${getDateString(new Date(Encabezado.Date || ""))}`,
//                 style: "infoGeneral",
//                 margin: [10, 0, 0, 0],
//                 border: [false, false, false, false]
//               },
//               {
//                 text: `${getLabel(ReporteLang, "agente", lenguaje)} ${Encabezado.UserNameAgent || ""}`,
//                 style: "infoGeneral",
//                 border: [false, false, false, false]

//               },
//             ], 
//             [
//               {
//                 text: `${getLabel(ReporteLang, "cliente", lenguaje)} ${Encabezado.CustomerName || ""}`,
//                 style: "infoGeneral",
//                 margin: [10, 0, 0, 0],

//                 border: [false, false, false, false]
//               },
//               {
//                 text: `${getLabel(ReporteLang, "terminoC", lenguaje)} ${Encabezado.TermNamePayment || ""}`,
//                 style: "infoGeneral",
//                 border: [false, false, false, false]
//               },
//             ], 
//             [
//               {
//                 text: `${getLabel(ReporteLang, "Buyer", lenguaje)} ${Encabezado.CompanyName || ""}`,
//                 style: "infoGeneral",
//                 margin: [10, 0, 0, 7],
//                 border: [false, false, false, true]
//               },
//               {
//                 text: `${getLabel(ReporteLang, "terminoE", lenguaje)} ${Encabezado.TermNameShitment || ""}`,
//                 style: "infoGeneral",
//                 border: [false, false, false, true],
//               },
//             ], 
//           ],
//         },
//         margin: [15, 5, 10, 0],
//       },

//       {
//         columns: [
//           {
//             margin: [16, 25, 10, 0],
//             table: {
//               widths: ['*', '*', '*', '*', '*', '*', '*', '*', '*'], 
//               body: [
//                 [
//                   { text: `${getLabel(ReporteLang, "styleC", lenguaje)}`, style: "headerTable" },
//                   { text: `${getLabel(ReporteLang, "hilo", lenguaje)}`, style: "headerTable" },
//                   { text: `${getLabel(ReporteLang, "styleT", lenguaje)}`, style: "headerTable" },
//                   { text: `${getLabel(ReporteLang, "dyeType", lenguaje)}`, style: "headerTable" },
//                   { text: `${getLabel(ReporteLang, "densidad", lenguaje)}`, style: "headerTable" },
//                   { text: `${getLabel(ReporteLang, "unidad", lenguaje)}`, style: "headerTable" },
//                   { text: `${getLabel(ReporteLang, "cantidad", lenguaje)}`, style: "headerTable" },
//                   { text: `${getLabel(ReporteLang, "UnitCost", lenguaje)}`, style: "headerTable" },
//                   { text: `${getLabel(ReporteLang, "Total", lenguaje)}`, style: "headerTable" },
//                 ],
//                 ...Detalles.flatMap(d => [
//                   [
//                     { text: `${d.StyleCategory || ""}`, style: 'textBody' },
//                     { text: `${d.Title || ""}`, style: 'textBody' },
//                     { text: `${d.FabricStyle || ""}`, style: 'textBody' },
//                     { text: `${d.DyeType || ""}`, style: 'textBody' },
//                     { text: `${d.Density || ""}`, style: 'textBody' },
//                     { text: `${d.UnitName || ""}`, style: 'textBody' },
//                     { text: `${formatNumberDecimal(d.Cantidad)}`, style: 'textBody' },
//                     { text: `${formatNumberDecimal(d.UnitCost)}`, style: 'textBody' },
//                     { text: `${formatNumberDecimal(d.UnitCost * d.Cantidad)}`, style: 'textBody' },
//                   ],
//                   [
//                     { 
//                       text: [
//                         {
//                           text: `${getLabel(ReporteLang, "comentario", lenguaje)}: `,
//                           style: 'headerTable1'
//                         },
//                         {
//                           text: `${d.Comment || ''}`,
//                           style: 'textBody1'
//                         }
//                       ],
//                       colSpan: 3, 
//                       margin: [5, 2, 5, 2] 
//                     },
//                     {}, {},
//                     { 
//                       text: [
//                         {
//                           text: `${getLabel(ReporteLang, "costo", lenguaje)}: `,
//                           style: 'headerTable1'
//                         },
//                         {
//                           text: `${(d.Adicionales?.filter((i) => i.IdTipo === 1))?.map(a => a.Description).join(', ') || 'Sin costos'}`,
//                           style: 'textBody1'
//                         }
//                       ],
//                       colSpan: 6, 
//                       margin: [5, 2, 5, 2] 
//                     }, 
//                     {}, {}, {}, {},{}
//                   ],
//                   [
//                     { text: '', colSpan: 9, border: [false, false, false, false], margin:[0,15,0,0] },
//                     {}, {}, {}, {}, {}, {}, {}, {}
//                   ]
//                 ])
//               ],
//             },
//             layout: 'lightHorizontalLines'
//           },
//         ],
//       },
      
      

//       //COMENTARIO
//       {
//         text: [
//           {
//             text: `${getLabel(ReporteLang, "comentario", lenguaje)}: `,
//             style: 'titulo2', 
//           },
//           {
//             text: `${Encabezado?.Comment || ''}`,
//             style: 'general',
//           },
//         ],
//         margin: [20, 50, 10, 0],
//       },

//       //TOTAL
//       {
//         text: [
//           {
//             text: `GRAND TOTAL: $ `,
//             style: 'textTotales', 
//           },
//           {
//             text: formatNumberDecimal(`${Encabezado?.TotalCotizacion}`), 
//             style: "textTotales2",  
//             margin: [-5, 0, 0, 0] 
//           },
//         ],
//         margin: [16, 25, 10, 40],
//       },

//       //FIRMA
//       {
//         columns: [
//           {
//             margin: [0, 70, 0, 0],

//             table: {
//               widths: [170, '*', 170],
//               body: [
//                 [
//                   {
//                     border: [false, false, false, false],
//                     text: '',
//                   },
//                   {
//                     border: [false, false, false, false],
//                     image: imgBlanca ? "data:image/png;base64," + imgBlanca : null,
//                     width: 50,
//                   },
//                   {
//                     border: [false, false, false, false],
//                     text: '', 
//                   },
//                 ],
//                 [
//                   {
//                     border: [false, false, false, false],
//                     text: '',
//                   },
//                   {
//                     border: [false, true, false, false],
//                     text: `${getLabel(ReporteLang,"firma",lenguaje)}`,
//                     // image: "data:image/png;base64," + imgBlanca,
//                     style: 'firmas', 

//                   },
//                   {
//                     border: [false, false, false, false],
//                     text: '',
//                   },
//                 ]

//               ]
//             }
//           }
//         ]
//       },

//       { text: '', pageBreak: 'before' },
      

//       //CONTENIDO
//       {
//         text: `${getLabel(ReporteLang,"title",lenguaje)}`,
//         style: 'title', 
//       },
//       {
//         text: `${getLabel(ReporteLang,"text1",lenguaje)}`,
//         style: 'text1', 
//         margin: [15, 15, 15, 0],
//       },
//       {
//         text: `${getLabel(ReporteLang,"text2",lenguaje)}`,
//         style: 'text1', 
//         margin: [15, 15, 15, 0],
//       },
//       {
//         text: `${getLabel(ReporteLang,"payment",lenguaje)}`,
//         style: 'text2', 
//         margin: [15, 15, 15, 0],
//       },
//       {
//         text: [
//           {
//             text: `${getLabel(ReporteLang, "text3", lenguaje)}`, 
//             style: 'text1',
//           },
//           {
//             text: ` ${Encabezado?.TermNamePayment || ''}`,  
//             style: 'textBlue',
//           },
//           {
//             text: `${getLabel(ReporteLang, "text3_2", lenguaje)}`,  
//             style: 'text1',
//           }
//         ],
//         margin: [35, 5, 15, 0], 
//       },
//       {
//         text: [
//           {
//             text: `${getLabel(ReporteLang,"text4",lenguaje)}`,
//             style: 'text1', 
//           },
//           {
//             text: `${getLabel(ReporteLang,"text4_1",lenguaje)}`,
//             style: 'textRed', 
//           },
//           {
//             text: `${getLabel(ReporteLang,"text4_2",lenguaje)}`,
//             style: 'text1', 
//           },
//         ],
//         margin: [35, 5, 15, 0],
//       },
//       {
//         text: `${getLabel(ReporteLang,"bank",lenguaje)}`,
//         style: 'text2', 
//         margin: [15, 15, 15, 0],
//       },
//       {
//         text: `${getLabel(ReporteLang,"text5",lenguaje)}`,
//         style: 'text1', 
//         margin: [35, 5, 15, 0],
//       },
//       {
//         text: `${getLabel(ReporteLang,"text6",lenguaje)}`,
//         style: 'text1', 
//         margin: [45, 5, 15, 0],
//       },
//       {
//         text: [
//           {
//             text: `${getLabel(ReporteLang,"shipping",lenguaje)}`,
//             style: 'text2', 
//           },
//           {
//             text: `${getLabel(ReporteLang,"text7",lenguaje)}`,
//             style: 'text1', 
//           }
//         ],
//         margin: [15, 15, 15, 0],
//       },
//       {
//         text: `${getLabel(ReporteLang,"yarn",lenguaje)}`,
//         style: 'text2', 
//         margin: [15, 15, 15, 0],
//       },
//       {
//         text: `${getLabel(ReporteLang,"text8",lenguaje)}`,
//         style: 'text1', 
//         margin: [35, 5, 15, 0],
//       },
//       {
//         text: `${getLabel(ReporteLang,"Non",lenguaje)}`,
//         style: 'text2', 
//         margin: [15, 15, 15, 0],
//       },
//       {
//         text: [
//           {
//             text: `${getLabel(ReporteLang,"text9",lenguaje)}`,
//             style: 'text1', 
//           },
//           {
//             text: `${getLabel(ReporteLang,"text9_1",lenguaje)}`,
//             style: 'text1_1', 
//           },
//           {
//             text: `${getLabel(ReporteLang,"text9_2",lenguaje)}`,
//             style: 'text1', 
//           },
//           {
//             text: `${getLabel(ReporteLang,"text9_3",lenguaje)}`,
//             style: 'text1_1', 
//           },
//           {
//             text: `${getLabel(ReporteLang,"text9_4",lenguaje)}`,
//             style: 'text1', 
//           },
//         ],
//         margin: [35, 5, 15, 0],
//       },
//       {
//         text: [
//           {
//             text: `${getLabel(ReporteLang,"text10",lenguaje)}`,
//             style: 'text1', 
//           },
//           {
//             text: `${getLabel(ReporteLang,"text10_1",lenguaje)}`,
//             style: 'text1_1', 
//           },
//           {
//             text: `${getLabel(ReporteLang,"text10_2",lenguaje)}`,
//             style: 'text1', 
//           },
//         ],
//         margin: [35, 5, 15, 0],
//       },
//       {
//         text: `${getLabel(ReporteLang,"validation",lenguaje)}`,
//         style: 'text2', 
//         margin: [15, 15, 15, 0],
//       },
//       {
//         text: [
//           {
//             text: `${getLabel(ReporteLang,"text11",lenguaje)}`,
//             style: 'text1', 
//           },
//           {
//             text: `${getLabel(ReporteLang,"text11_1",lenguaje)}`,
//             style: 'text1_1', 
//           },
//           {
//             text: `${getLabel(ReporteLang,"text11_2",lenguaje)}`,
//             style: 'text1', 
//           },
//         ],
//         margin: [35, 5, 15, 0],
//       },
//       {
//         text: `${getLabel(ReporteLang,"text12",lenguaje)}`,
//         style: 'text1', 
//         margin: [35, 5, 15, 0],
//       },
//       {
//         text: [
//           {
//             text: `${getLabel(ReporteLang,"text13",lenguaje)}`,
//             style: 'text1', 
//           },
//           {
//             text: `${Encabezado?.CustomerName || ''}`,
//             style: 'text1', 
//           },
//           {
//             text: `${getLabel(ReporteLang,"text13_1",lenguaje)}`,
//             style: 'text1', 
//           },
//           {
//             text: `${Encabezado?.CustomerName || ''}`,
//             style: 'text1', 
//           },
//           {
//             text: `${getLabel(ReporteLang,"text13_2",lenguaje)}`,
//             style: 'text1', 
//           },
//           {
//             text: `${Encabezado?.CustomerName || ''}`,
//             style: 'text1', 
//           },
//           {
//             text: `${getLabel(ReporteLang,"text13_3",lenguaje)}`,
//             style: 'text1', 
//           },
          
//         ],
//         margin: [35, 5, 15, 0],
//       },
//       {
//         text:[
//           {
//             text: `${getLabel(ReporteLang,"text14",lenguaje)}`,
//             style: 'text1', 
//           },
//           {
//             text: `${getLabel(ReporteLang,"text14_1",lenguaje)}`,
//             style: 'text1_1', 
//           },
//           {
//             text: `${getLabel(ReporteLang,"text14_2",lenguaje)}`,
//             style: 'text1', 
//           },
//         ],
//         margin: [35, 5, 15, 0],
//       },
//       {
//         text: [
//           {
//             text: `${getLabel(ReporteLang,"text15",lenguaje)}`,
//             style: 'text1', 
//           },
//           {
//             text: `${getLabel(ReporteLang,"text15_1",lenguaje)}`,
//             style: 'text1_1', 
//           },
//         ],
//         margin: [35, 5, 15, 50],
//       },
//       {
//         text: `${getLabel(ReporteLang,"return",lenguaje)}`,
//         style: 'text2', 
//         margin: [15, 15, 15, 0],
//       },
//       {
//         text: `${getLabel(ReporteLang,"text16",lenguaje)}`,
//         style: 'text1', 
//         margin: [35, 10, 15, 0],
//       },
//       {
//         text: `${getLabel(ReporteLang,"types",lenguaje)}`,
//         style: 'text2', 
//         margin: [15, 15, 15, 0],
//       },
//       {
//         text: `${getLabel(ReporteLang,"text17",lenguaje)}`,
//         style: 'text1', 
//         margin: [35, 5, 15, 0],
//       },
//       {
//         text: `${getLabel(ReporteLang,"cargos",lenguaje)}`,
//         style: 'text2', 
//         margin: [15, 15, 15, 0],
//       },
//       {
//         text: `${getLabel(ReporteLang,"text18",lenguaje)}`,
//         style: 'text1', 
//         margin: [35, 5, 15, 0],
//       },
//       {
//         text: `${getLabel(ReporteLang,"text19",lenguaje)}`,
//         style: 'text1', 
//         margin: [35, 5, 15, 0],
//       },
//       {
//         text: `${getLabel(ReporteLang,"text20",lenguaje)}`,
//         style: 'text1', 
//         margin: [35, 5, 15, 0],
//       },
//       {
//         text: `${getLabel(ReporteLang,"text21",lenguaje)}`,
//         style: 'text1', 
//         margin: [35, 5, 15, 0],
//       },
//       {
//         text: `${getLabel(ReporteLang,"fuerza",lenguaje)}`,
//         style: 'text2', 
//         margin: [15, 15, 15, 0],
//       },
//       {
//         text: [
//           {
//             text: `${getLabel(ReporteLang,"text22",lenguaje)}`,
//             style: 'text1', 
//           },
//           {
//             text: `${getLabel(ReporteLang,"text22_1",lenguaje)}`,
//             style: 'text1_1', 
//           },
//           {
//             text: `${getLabel(ReporteLang,"text22_2",lenguaje)}`,
//             style: 'text1', 
//           },
//         ], 
//         margin: [35, 5, 15, 0],
//       },
//       {
//         text: `${getLabel(ReporteLang,"text23",lenguaje)}`,
//         style: 'text1', 
//         margin: [15, 25, 15, 0],
//       },


//       //FIRMAS
//       {
//         columns: [
//           {
//             margin: [30, 125, 30, 0],
//             table: {
//               widths: ['*', '*', '*'],
//               body: [
//                 [
//                   {
//                     border: [false, true, false, false],
//                     text: `${getLabel(ReporteLang,"firmaContenido",lenguaje)}`,
//                     style: 'firmas', 
//                   },
//                   {
//                     border: [false, false, false, false],
//                     text: '', width: [100]
//                   },
//                   {
//                     border: [false, true, false, false],
//                     text: `${getLabel(ReporteLang,"firmaContenido",lenguaje)}`,
//                     style: 'firmas', 
//                   },
//                 ],
//                 [
//                   {
//                     border: [false, false, false, false],
//                     text: `${getLabel(ReporteLang,"firmaContenido1",lenguaje)}`,
//                     style: 'firmas', 
//                   },
//                   {
//                     border: [false, false, false, false],
//                     text: '', width: [100]
//                   },
//                   {
//                     border: [false, false, false, false],
//                     text: `${Encabezado?.CustomerName || ''}`,
//                     style: 'firmas', 
//                   },
//                 ]
//               ]
//             }
//           }
//         ]
//       },

//     ],

//     // ESTILOS
//     styles: {
//       titulo: {
//         fontSize: 11,
//         bold: true,
//         alignment: "center",
//       },
//       titulo2: {
//         fontSize: 8.5,
//         bold: true,
//         alignment: "justify",
//       },
//       general: {
//         fontSize: 8.5,
//         alignment: "justify",
//       },
//       titulo3: {
//         fontSize: 8.5,
//         semmibold: true,
//         alignment: "justify",
//       },
//       header: {
//         fontSize: 9,
//         alignment: "justify",
//         bold: true,
//       },
//       infoGeneral: {
//         fontSize: 8.5,
//         alignment: 'justify'
//       },
//       headerTable: {
//         fontSize: 7.5,
//         alignment: "center",
//         bold: true,
//       },
//       headerTable1: {
//         fontSize: 8,
//         // alignment: "center",
//         bold: true,
//       },
//       textBody: {
//         fontSize: 8,
//         alignment: "center",
//       },  
//       textBody1: {
//         fontSize: 8,
//         alignment: "justify",
//       },            
//       textTotales: {
//         bold: true,
//         fontSize: 10,
//         alignment: "right",
//       },
//       textTotales2: {
//         bold: true,
//         fontSize: 10,
//         alignment: "left",
//       },
//       footer: {
//         fontSize: 7.5,
//         alignment: "left",
//         margin: [30, 0, 5, 0],
//       },
//       firmas: {
//         fontSize: 8,
//         bold: true,
//         alignment: "center",
//         lineHeight: 1,
//       },
//       //CONTENIDO
//       title: {
//         fontSize: 13,
//         bold: true,
//         alignment: "center",
//       },
//       text1: {
//         fontSize: 9,
//         alignment: "justify",
//       },
//       text1_1: {
//         fontSize: 9,
//         alignment: "justify",
//         bold: true,
//       },
//       text2: {
//         fontSize: 9,
//         bold: true,
//         alignment: "justify",
//       },
//       textBlue: {
//         fontSize: 9,
//         bold: true,
//         alignment: "justify",
//         color: "blue",
//       },
//       textRed: {
//         fontSize: 9,
//         bold: true,
//         alignment: "justify",
//         color: "red",
//       },
//     },
//   };

//   const doc = pdfMake.createPdf(docDefinition);

//   doc.getDataUrl((url) => {
//     setPdfUrl(url); 
//   });
// };
